<template>
    <div id="wrapper">
        <Director-Bar index="7"></Director-Bar>
  
      <div id="content-wrapper">
        <div class="container-fluid">
        
        </div>
        <!-- /.container-fluid -->
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";

  import DirectorBar from "../Bonus/Bonus_Bar.vue";

  export default {
    name: "Roles",
    components: {
 
      DirectorBar,
    },
    computed: {


    },
    data() {
      return {
       
      };
    },
 
    methods: {
    

    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  